import useWindowScrollPosition from 'hooks/useWindowScrollPosition';
import { useEffect } from 'react';

const useThrottledWindowScrollPosition = ({
  callback,
  time,
  isScrollTrackingDisabled = false,
  previousScrollPosition,
}) => {
  const throttledScrollPosition = useWindowScrollPosition({
    isScrollTrackingDisabled,
    time,
    previousScrollPosition,
  });

  useEffect(() => {
    callback(throttledScrollPosition);
  }, [callback, throttledScrollPosition]);
};

export default useThrottledWindowScrollPosition;
